module.exports = __webpack_public_path__ + "img/lock.a61d4f2d.svg";